// src\utils\data.js


import carbon_ai from "../../src/images/carbon_intel_dashb.PNG";
import seismic_ai from "../../src/images/seismic_ai.PNG";
import climate_tokens from "../../src/images/blockchain_tokens.PNG";
import azure_ml from "../../src/images/azure_ml.PNG";
import energyx from "../../src/images/dashb.PNG"
import energyx_ship from "../../src/images/exzingx-ship2.png"


export const lushRide_intro = [
  {
    media_id: 1,
    media_src: null,
    media_title: "LushRide",
    media_desc: `Our flagship product, LUSHRIDE, is a car-hailing service that raises
                  e-riders consciousness on their carbon footprint (COe) during
                  driving sessions. We're currently leveraging the XRPL robust chain
                  to create NFT tokens for users' carbon footprints, with the aim of
                  giving them a choice of monetizing or analysing their data for
                  global climate change mitigation.
                  ,`
                  ,
  },
];

export const exzing_energyx_intro = [
    {
      media_id: 1,
      media_src: null,
      media_img: energyx_ship,
      media_title: "Exzing EnergyX",
      media_desc: `Launched in 2025, Exzing EnergyX is a climate tech platform powered by AI, 
                   Microsoft Azure (including Azure ML), and blockchain technologies like Ocean Protocol and Ethereum.
                   Based in Nigeria, we’re pioneering carbon intelligence tools in a region where such solutions are still rare.
                   Our mission is to empower concerned organisations,  maritime operators and port stakeholders with real-time emissions data, 
                   intelligent analytics, and actionable insights. At this early stage, we’re equipping users with
                   baseline tools for understanding and managing their carbon footprint — laying the groundwork for a smarter, more sustainable maritime future.
                   Learn more at <a href="https://energyx.exzing.com" target="_blank" rel="noopener noreferrer">Exzing EnergyX</a>.`,
    },
  ];
  
  
export const exzing_reservoir_agent_intro = [
  {
    media_id: 1,
    media_src: null,
    media_img: null,
    media_title: "Reservoir Management Agent",
    media_desc: `Launched in 2026 and available on the <b>Microsoft Commercial Marketplace</b>, 
                 Exzing Reservoir Management Agent is an enterprise-grade AI orchestration platform 
                 built for subsurface engineering. It automates the complex lifecycle of reservoir 
                 simulations (E), leveraging Azure OpenAI to debug keywords and ACI for 
                 scalable execution. By reducing simulation cycle times by up to 90%, we empower 
                 upstream operators to make faster, data-driven production decisions. 
                 Explore the solution on the <a href="https://marketplace.microsoft.com/en-us/product/saas/okpo-exzing-research.exzing-reservoir-agent?tab=Overview" target="_blank" rel="noopener noreferrer">Exzing Reservoir Agent</a>.`,
  },
];
  

  export const partners_intro = [
    {
      media_id: 1,
      media_src: null,
      media_title: "We Grow Together",
      media_desc: `We are proudly part of Microsoft for Startups Founders Hub (Now Microsoft for Startups). 
                  We are grateful for the support and resources provided by Microsoft, which have been instrumental in
                  our journey as a startup. The availability
                  of High Performance Computing (HPC) resources and GPUs have been a game-changer
                  for us, enabling us to develop and deploy our AI models with greater
                  efficiency and speed. This support has been crucial in our mission to
                  create innovative solutions that address real-world challenges. 
                  We welcome more partners as they join us to build impactful solutions for a sustainable future.`,
    },
  ];
  

  export const demo_media = [
  {
    media_id: 0,
    media_src: "https://www.youtube.com/embed/eHuHLZx5Rio",
    media_title: "LushRide Web2 MVP Demo",
    media_desc: "",
  },
  {
    media_id: 1,
    media_src: "https://www.youtube.com/embed/ZxuGu63V7WY",
    media_title: "LushRide-XRPL Integration",
    media_desc: "",
  },
];


export const services_image = [
  {
    media_id: 0,
    media_name: carbon_ai,
    media_title: "Carbon Intelligence & CCUS Tools",
    media_desc:
      `We develop real-time carbon monitoring tools powered by AI to help organisations and maritime operators track/reduce their emissions footprint.
      Our long term goal also include carbon capture and sequestration`,
  },
  {
    media_id: 1,
    media_name: azure_ml,
    media_title: "Azure ML-Powered Solutions",
    media_desc:
      "Through Microsoft for Startups, we deploy scalable AI pipelines using Azure ML, HPC, and cloud-native tooling to build sustainable systems.",
  },
  {
    media_id: 2,
    media_name: climate_tokens,
    media_title: "Blockchain & CO₂ Tokens",
    media_desc:
      "We use XRPL to tokenize carbon data, enabling users to monetize or trace their environmental impact via NFTs and decentralized tools.",
  },

  {
    media_id: 3,
    media_name: seismic_ai,
    media_title: "Seismic AI for Subsurface Insights",
    media_desc:
      "Leveraging deep learning models like UNet and ElasticViTMAE to enhance geophysical simulations and reservoir predictions.",
  },
];

